<template>
  <div v-if="$vuetify.breakpoint.smAndDown">
    <v-row>
      <!-- Provider -->
      <v-col
        class="d-flex flex-column justify-center align-center
                  table-right-border table-right-border-light pa-2
                  result-columns-align-width"
      >
        <div @click="$emit('open-more-info')">
          <img
            :src="details.imageSiteRemote"
            :alt="details.brokerFullName"
            class="provider-logo"
          >
          <results-price
            :quote="quote"
            :monthly="isViewMonthly"
            :cashback="cashback"
          />
        </div>
      </v-col>

      <!-- Vet Fee Limits -->
      <v-col
        class="d-flex flex-column justify-center table-right-border table-right-border-light pa-2 result-columns-align-width fs-13"
      >
        <p>Vet Fee limits:</p>
        <p class="mb-0">{{ coverTypeRelatedLabel }} limit:</p>
        <p class="font-weight-bold mb-0">{{ helpers.getExtrasPrice(optionalExtra.vetsFee) }}</p>
        <p
          v-if="optionalExtra.vetsFee.extraText"
          class="caption"
        >
          {{ optionalExtra.vetsFee.extraText }}
        </p>
        <p class="mb-0">Annual Policy limit:</p>
        <p class="font-weight-bold">{{ helpers.getExtrasPrice(optionalExtra.annualPolicyLimit) }}</p>
        <p class="mb-0">Vet Excess: <span class="font-weight-bold">{{ helpers.getExtrasPrice(optionalExtra.vetExcess) }}</span> {{ details.compulsoryExtraText }}</p>
      </v-col>

      <!-- Policy details -->
      <v-col
        class="d-flex flex-column justify-center align-center text-center pa-2
                        result-columns-align-width"
      >
        <v-btn
          rounded
          color="success"
          @click="$emit('click-policy-details')"
        >
          <span>More</span>
        </v-btn>
      </v-col>
    </v-row>

    <div
      v-if="coveredExtraLabels.length"
      class="covered-extra-labels"
    >
      <v-divider class="mt-3" />

      <ul class="d-flex flex-wrap pl-0 pt-3">
        <li
          v-for="(extra, index) in coveredExtraLabels"
          :key="index"
          class="col-6 pa-1 d-flex align-start"
        >
          <v-icon
            color="primary"
            class="mr-1"
          >
            mdi-check
          </v-icon>
          <p class="flex-grow-1 mb-0">
            {{ extra }}
          </p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import ResultsPrice from '@/components/pet/Results/ResultsPrice.vue';

export default {
  name: 'quote-mobile',
  components: {
    ResultsPrice,
  },
  inject: ['helpers'],
  props: {
    quote: {
      type: Object,
      required: true,
    },
    isViewMonthly: {
      type: Boolean,
      required: true,
    },
    details: {
      type: Object,
      required: true,
    },
    optionalExtra: {
      type: Object,
      required: true,
    },
    coverTypeRelatedLabel: {
      type: String,
      default: '',
    },
    coveredExtraLabels: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    cashback () {
      return +this.quote.details[0].cashback;
    },
  },
};
</script>

<style scoped lang="scss">
.provider-logo {
  display: block;
  max-width: 100%;
  height: auto;
}
// compensate parent gaps in order to make component more symmetrical
.covered-extra-labels {
  position: relative;
  bottom: -20px;
}
</style>
